(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mav-apparel-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mav-apparel')) {
  customElements.define('mav-apparel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('.mapparel__filters').hidden = false;
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        const all = event.target.closest('[data-show-all]');
        if (!filter && !all) return;
        if (all) event.preventDefault();
        const category = filter ? filter.dataset.filter : 'all';
        const update = () => {
          let count = 0;
          this.querySelectorAll('[data-category]').forEach(card => {
            card.hidden = category !== 'all' && card.dataset.category !== category;
            if (!card.hidden) count++;
          });
          this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
          const status = this.querySelector('[data-result-status]');
          status.textContent = status.dataset.template.replace('[count]', count);
          this.querySelector('.mapparel__empty').hidden = count > 0;
          if (all) requestAnimationFrame(() => this.querySelector('.mapparel__shop').scrollIntoView({block: 'start'}));
        };
        if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update); else update();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mav-gear-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mav-gear')) {
  customElements.define('mav-gear', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('.mgear__filters').hidden = false;
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        const all = event.target.closest('[data-show-all]');
        if (!filter && !all) return;
        if (all) event.preventDefault();
        const category = filter ? filter.dataset.filter : 'all';
        const update = () => {
          let count = 0;
          this.querySelectorAll('[data-category]').forEach(card => {
            card.hidden = category !== 'all' && card.dataset.category !== category;
            if (!card.hidden) count++;
          });
          this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
          const status = this.querySelector('[data-result-status]');
          status.textContent = status.dataset.template.replace('[count]', count);
          if (all) requestAnimationFrame(() => this.querySelector('.mgear__shop').scrollIntoView({block: 'start'}));
        };
        if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update); else update();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mav-paddle-finder"]) return;
  try {
    
if (!customElements.get('mav-paddle-finder')) {
  customElements.define('mav-paddle-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-paddle]')];
      this.performance = 'all'; this.skill = 'all';
      this.selected = new Set();
      this.dialog = this.querySelector('dialog');
      this.paramsToState();
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-performance')) { this.performance = button.dataset.performance; this.update(true); }
        if (button.hasAttribute('data-skill')) { this.skill = button.dataset.skill; this.update(true); }
        if (button.hasAttribute('data-reset')) { this.performance = 'all'; this.skill = 'all'; this.update(true); }
        if (button.hasAttribute('data-clear-compare')) { this.selected.clear(); this.syncComparison(); }
        if (button.hasAttribute('data-open-compare')) this.openComparison();
        if (button.hasAttribute('data-close-compare')) this.dialog.close();
        if (button.hasAttribute('data-compare-help')) {
          this.querySelector('[data-compare-bar]').scrollIntoView({block:'center',behavior:'auto'});
          const checkbox = this.cards.find(card => !card.hidden)?.querySelector('[data-compare]');
          checkbox?.focus({preventScroll:true});
        }
      });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-skill-select]')) { this.skill = event.target.value; this.update(true); }
        if (event.target.matches('[data-compare]')) {
          const id = event.target.closest('[data-paddle]').dataset.id;
          if (event.target.checked && this.selected.size >= 3) { event.target.checked = false; this.querySelector('[data-notice]').textContent = this.dataset.limit; return; }
          if (event.target.checked) this.selected.add(id); else this.selected.delete(id);
          this.querySelector('[data-notice]').textContent = '';
          this.syncComparison();
        }
      });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) this.dialog.close(); } });
      this.onPop = () => { this.paramsToState(); this.update(false); };
      window.addEventListener('popstate', this.onPop);
      this.update(false); this.syncComparison();
    }
    disconnectedCallback() { window.removeEventListener('popstate',this.onPop); this.ready=false; }
    paramsToState() {
      const p = new URL(location.href).searchParams;
      this.performance = ['power','control','all_court'].includes(p.get('performance')) ? p.get('performance') : 'all';
      this.skill = ['beginner','intermediate','advanced'].includes(p.get('skill')) ? p.get('skill') : 'all';
    }
    update(writeURL) {
      let count=0;
      this.cards.forEach(card => {
        const match = (this.performance==='all' || card.dataset.category===this.performance) && (this.skill==='all' || card.dataset.levels.split(',').includes(this.skill));
        card.hidden = !match; if(match) count++;
      });
      this.querySelectorAll('[data-performance]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.performance===this.performance)));
      this.querySelectorAll('[data-skill]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.skill===this.skill)));
      this.querySelector('[data-skill-select]').value=this.skill;
      this.querySelector('[data-skill-select]').classList.toggle('is-active',this.skill!=='all');
      this.querySelector('[data-result-count]').textContent=`${count} ${this.dataset.matches}`;
      this.querySelector('[data-empty]').hidden=count!==0;
      this.querySelector('.mpf__filters [data-reset]').disabled=this.performance==='all' && this.skill==='all';
      if(writeURL){const url=new URL(location.href);for(const [key,value] of [['performance',this.performance],['skill',this.skill]]){if(value==='all')url.searchParams.delete(key);else url.searchParams.set(key,value);}history.replaceState({},'',url);}
    }
    syncComparison() {
      this.cards.forEach(card=>{card.querySelector('[data-compare]').checked=this.selected.has(card.dataset.id);});
      this.querySelector('[data-selection-count]').textContent=this.selected.size ? `${this.selected.size}/3 ${this.dataset.selected}` : '';
      this.querySelectorAll('[data-clear-compare]').forEach(b=>b.hidden=!this.selected.size);
      this.querySelector('[data-floating]').hidden=this.selected.size<2;
      this.querySelector('[data-floating-count]').textContent=`${this.selected.size}/3 ${this.dataset.selected}`;
      this.querySelectorAll('[data-open-compare]').forEach(b=>b.disabled=this.selected.size<2);
    }
    openComparison() {
      if(this.selected.size<2)return;
      const target=this.querySelector('[data-comparison]');target.replaceChildren();target.style.setProperty('--columns',this.selected.size);
      this.cards.filter(c=>this.selected.has(c.dataset.id)).forEach(card=>{
        const fragment=this.querySelector('[data-compare-template]').content.cloneNode(true);
        for(const [slot,selector] of Object.entries({photo:'.mpf__photo',title:'[data-title]',price:'[data-price]',dimensions:'[data-dimensions]',weight:'[data-weight]',generation:'[data-generation]',construction:'[data-construction]',core:'[data-core]',face:'[data-face]',power:'[data-power]',pop:'[data-pop]',control:'[data-control]',style:'[data-style]',feel:'[data-feel]',best:'[data-best]',availability:'[data-availability]',link:'[data-product-link]'})){
          const destination=fragment.querySelector(`[data-slot="${slot}"]`); const source=card.querySelector(selector);
          if(['photo','link'].includes(slot))destination.append(source.cloneNode(true));else destination.textContent=source.textContent;
        }
        target.append(fragment);
      });
      this.dialog.showModal();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
